// src/analytics/connModeLogger.ts
type Mode = 'full' | 'balanced' | 'lite' | 'offline';

const KEY = 'YS_CONN_LOG_QUEUE';
const SEEN = 'YS_CONN_LAST_SENT'; // de-dupe per session

function enqueue(payload: any) {
  const q = JSON.parse(localStorage.getItem(KEY) || '[]');
  q.push(payload);
  localStorage.setItem(KEY, JSON.stringify(q));
}

function flushQueue() {
  const raw = localStorage.getItem(KEY);
  if (!raw) return;
  const q: any[] = JSON.parse(raw);
  if (!q.length) return;

  // Send in one batch; replace URL with your endpoint or Supabase Edge Function
  fetch('/api/log-conn-mode', {
    method: 'POST',
    headers: {'Content-Type':'application/json'},
    body: JSON.stringify({ events: q }),
    keepalive: true, // survives page unload
  }).then(() => localStorage.removeItem(KEY))
    .catch(() => {/* keep queue; try later */});
}

export function logConnMode(mode: Mode) {
  try {
    // De-dupe: don't spam same mode twice in a row
    const last = sessionStorage.getItem(SEEN);
    if (last === mode) return;
    sessionStorage.setItem(SEEN, mode);

    const nav: any = (navigator as any);
    const c: any = nav.connection || {};
    const payload = {
      ts: Date.now(),
      mode,                                     // 'full' | 'balanced' | 'lite' | 'offline'
      et: c.effectiveType ?? null,              // '4g'|'3g' etc.
      dl: typeof c.downlink === 'number' ? c.downlink : null, // Mbps
      sd: !!c.saveData,                         // Data Saver
      online: typeof navigator.onLine === 'boolean' ? navigator.onLine : null,
      // OPTIONAL: a simple random session id (not PII)
      sid: sessionStorage.getItem('YS_SID') || (() => {
        const id = Math.random().toString(36).slice(2);
        sessionStorage.setItem('YS_SID', id);
        return id;
      })(),
    };

    enqueue(payload);

    const send = () => flushQueue();
    if ('requestIdleCallback' in window) {
      (window as any).requestIdleCallback(send, { timeout: 2000 });
    } else {
      setTimeout(send, 0);
    }
  } catch { /* never throw from analytics */ }
}

// Helpful on app start/when network returns
export function tryFlushConnLogsSoon() {
  try {
    if (!navigator.onLine) return;
    const send = () => flushQueue();
    if ('requestIdleCallback' in window) (window as any).requestIdleCallback(send, { timeout: 1500 });
    else setTimeout(send, 250);
  } catch {}
}